import { defineMessages } from 'react-intl'

const createRouteMessages = {
  messages: defineMessages({
    heading: {
      id: 'route.landing.createownroute',
      defaultMessage: 'Create Your Own Route',
    },
    button: {
      id: 'route.landing.createroute',
      defaultMessage: 'Create Route',
    },
  }),
  icons: [
    {
      name: 'ic-sheild',
      message: defineMessages({
        definition: {
          id: 'route.landing.staysafe',
          defaultMessage: 'Stay Safe',
        },
      }),
    },
    {
      name: 'ic-water',
      message: defineMessages({
        definition: {
          id: 'route.landing.planlogistics',
          defaultMessage: 'Plan Logistics',
        },
      }),
    },
    {
      name: 'ic-terrain',
      message: defineMessages({
        definition: {
          id: 'route.landing.knowtheterrain',
          defaultMessage: 'Know The Terrain',
        },
      }),
    },
  ],
}

export default createRouteMessages

